import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  contentChildren,
  ElementRef,
  signal,
  ViewChild,
} from '@angular/core';
import { TabsItemComponent } from './tabs-item/tabs-item.component';

@Component({
  standalone: true,
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.css'],
  imports: [CommonModule],
})
export class TabsComponent implements AfterViewInit {
  @ViewChild('tabsWrapper', { static: false }) tabsWrapper!: ElementRef;
  tabItems = contentChildren(TabsItemComponent);
  tabTitles = signal<string[]>([]);
  selectedTitle = signal<string>('');
  current: number;
  leftArrowVisible: boolean;
  rightArrowVisible: boolean;

  ngAfterViewInit(): void {
    const titles = new Array<string>();

    let hasActive = false;
    this.rightArrowVisible = this.tabItems().length > 8;
    this.tabItems().forEach((tabItem) => {
      titles.push(tabItem.title);
      if (!hasActive && tabItem.active) {
        hasActive = true;
        this.onTabSelected(tabItem.title);
      }
    });

    if (!hasActive && this.tabItems().length > 0) {
      this.onTabSelected(this.tabItems()[0].title);
    }
    this.tabTitles.set(titles);

    this.tabsWrapper.nativeElement.addEventListener(
      'wheel',
      function (e) {
        e.preventDefault();
      },
      { passive: false }
    );

    this.tabsWrapper.nativeElement.addEventListener('scroll', () => {
      this.checkScrollPosition();
    });
  }

  onTabSelected(title: string): void {
    this.tabItems().forEach((tabItem, index) => {
      tabItem.active = tabItem.title === title;
      if (tabItem.active) {
        this.current = index;
      }
    });
    this.selectedTitle.set(title);
  }

  tabLinkClass(title: string): string {
    return this.selectedTitle() === title ? 'tab-active' : undefined;
  }

  scrollTabs(direction: 'left' | 'right'): void {
    const wrapper = this.tabsWrapper.nativeElement;

    wrapper.scrollBy({
      left: direction === 'left' ? 98 : -98,
      behavior: 'smooth',
    });
  }

  checkScrollPosition() {
    const scrollLeft = this.tabsWrapper.nativeElement.scrollLeft;
    const scrollWidth = this.tabsWrapper.nativeElement.scrollWidth;
    const clientWidth = this.tabsWrapper.nativeElement.clientWidth;

    this.leftArrowVisible = scrollLeft > 0;
    this.rightArrowVisible = scrollLeft < scrollWidth - clientWidth - 2;
  }
}
